import React from 'react';
import Radium from 'radium';
import { reduxForm } from 'redux-form';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import { func, number, bool, string } from 'prop-types';
import { UTButton, UTLabel, WithLoading } from '@widergy/energy-ui';

import UTForm from 'app/components/UTForm';
import { message } from 'utils/stringUtils';
import { CHANGE_EXPIRATION_DATE } from 'constants/reduxForms';
import { FIELD_TEXT } from 'constants/userForms';

import { START_DAY, END_DAY } from './constants';
import styles from './styles';

const fields = [
  { id: 1, type: FIELD_TEXT, key: START_DAY, title: message('ChangeDueDate:startDay'), read_only: true },
  { id: 1, type: FIELD_TEXT, key: END_DAY, title: message('ChangeDueDate:endDay'), read_only: true }
];

const ChangeDueDate = ({
  onChangeSlider,
  onInitChange,
  onChangeExpirationDays,
  startDay,
  endDay,
  canChange,
  mssg
}) => (
  <div style={styles.content}>
    <UTLabel black>{mssg}</UTLabel>
    <UTForm fields={fields} />
    <UTLabel black>{message('ChangeDueDate:sliderHelp')}</UTLabel>
    <div style={styles.slider}>
      <InputRange
        allowSameValues
        maxValue={31}
        minValue={1}
        value={{ min: startDay, max: endDay }}
        onChangeStart={onInitChange}
        onChange={onChangeSlider}
      />
    </div>
    <UTButton disabled={!canChange} onPress={onChangeExpirationDays}>
      {message('Commons:modify')}
    </UTButton>
  </div>
);

ChangeDueDate.propTypes = {
  onChangeSlider: func.isRequired,
  onInitChange: func.isRequired,
  onChangeExpirationDays: func.isRequired,
  startDay: number,
  endDay: number,
  canChange: bool,
  mssg: string
};

export default reduxForm({ form: CHANGE_EXPIRATION_DATE })(
  WithLoading(props => props.loading)(Radium(ChangeDueDate))
);
